import AddNewPeriodModal from './AddNewPeriodModal';
import AddNewPeriodModalConnector from './AddNewPeriodModalConnector';

const ConnectedComponent = () => <AddNewPeriodModalConnector component={AddNewPeriodModal} />;

export default ConnectedComponent;
